import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import CONFIG from "../../Config";
import Service from "Service/Service";


let authheaderAllData = Service.infoDataHead();

// =============== FactReport/SaveMADReportRequest =================
export const SaveMADReport = createAsyncThunk(
  "SaveMADReport",
  async (userdata, thunkAPI) => {
    console.log("object", userdata);
    try {
      const result = await axios(
        userdata?.seconddata?.type === 2 ?
          {
            method: "POST",
            baseURL: CONFIG.BASE_URL_ALL,
            url: `FactReport/ImportMADReportRequest`,
            headers: {
              ...authheaderAllData,
              "Content-Type": "multipart/form-data"
            },
            data: userdata?.from,
          } : {

            method: "POST",
            baseURL: CONFIG.BASE_URL_ALL,
            url: `FactReport/SaveMADReportRequest`,
            headers: authheaderAllData,
            data: userdata,
          });
      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ SaveMADReport ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
export const SaveMADReportUpload = createAsyncThunk(
  "SaveMADReportUpload",
  async (userdata, thunkAPI) => {
    console.log(userdata)
    try {
      const result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `FactReport/ImportMADReportRequest?userName=${userdata.userName}&reportType=${userdata.reportType}`,
        headers: {
          ...authheaderAllData,
          "Content-Type": "multipart/form-data"
        },
        data: userdata.form,
      });
      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ SaveMADReportUpload ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

//========FactReport/GetMADReportRequestList ============
export const GetMADReportTable = createAsyncThunk(
  "GetMADReportTable",
  async (userdata, thunkAPI) => {
    try {
      const result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: "FactReport/GetMADReportRequestList",
        headers: authheaderAllData,
        params: userdata,
      });
      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ GetMADReportTable ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

//========FactReport/GetMADReportClientConfig ============
export const GetMADReportClientConfig = createAsyncThunk(
  "GetMADReportClientConfig",
  async (userdata, thunkAPI) => {
    try {
      const result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: "FactReport/GetMADReportClientConfig",
        headers: authheaderAllData,
        params: userdata,
      });
      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ GetMADReportClientConfig ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

//========FactReport/SaveMADReportClientConfig ============
export const SaveMADReportClientConfig = createAsyncThunk(
  "SaveMADReportClientConfig",
  async (userdata, thunkAPI) => {
    try {
      const result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        url: "FactReport/SaveMADReportClientConfig",
        headers: authheaderAllData,
        data: userdata,
      });
      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ SaveMADReportClientConfig ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
//========FactReport/GetMADKYCReport ============
export const GetMADKYCReportApi = createAsyncThunk(
  "GetMADKYCReportApi",
  async (userdata, thunkAPI) => {
    try {
      const result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: "FactReport/GetMADReport",
        headers: authheaderAllData,
        params: userdata,
      });
      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ GetMADKYCReportApi ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
//FactReport/SavePolygons
export const SavePolygons = createAsyncThunk(
  "SavePolygons",
  async ({ userName, polygonData }, thunkAPI) => {
    try {
      const result = await axios({
        method: "POST",
        baseURL: "https://172.168.1.84:7276",
        // baseURL: CONFIG.BASE_URL_ALL,
        url: `FactReport/SavePolygons`,
        headers: authheaderAllData,
        params: { userName },
        data: polygonData,
      });

      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ SavePolygons ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
//FactReport/GetMCAReportListByUserName
export const GetMCAReportListByUserName = createAsyncThunk(
  "GetMCAReportListByUserName",
  async (userName, thunkAPI) => {
    try {
      const result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `MCA/GetMCAReportListByUserName`,
        headers: authheaderAllData,
        params: userName,
      });

      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ GetMCAReportListByUserName ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
//FactReport/SearchMCACompanies
export const SearchMCACompanies = createAsyncThunk(
  "SearchMCACompanies",
  async (searchPayload, thunkAPI) => {
    try {
      const result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `MCA/SearchCompany`,
        headers: authheaderAllData,
        data: searchPayload,
      });

      if (result.data) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ searchPayload ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
//FactReport/SaveMCAReport
export const SaveMCAReport = createAsyncThunk(
  "SaveMCAReport",
  async (searchPayload, thunkAPI) => {
    console.log("searchPayload,,", searchPayload)
    try {
      const result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `MCA/SaveMCAReportMaster`,
        headers: authheaderAllData,
        data: searchPayload,
      });

      if (result.data) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ SaveMCAReport ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
//FactReport/MADReportRequestSelection
export const MADReportRequestSelection = createAsyncThunk(
  "MADReportRequestSelection",
  async (searchPayload, thunkAPI) => {
    try {
      const result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `FactReport/MADReportRequestSelection`,
        headers: authheaderAllData,
        data: searchPayload,
      });

      if (result.data) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ SaveMCAReport ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
export const MADSlice = createSlice({
  name: "MADSlice",
  initialState: {
    successMessageMad: "",
    errorMessageMad: "",
    isErrorMad: false,

    isSaveMADReport: false,
    isSaveMADReportFetching: false,

    isSaveMADReportUpload: false,
    isSaveMADReportUploadFetching: false,

    isGetMADReportTable: false,
    isGetMADReportTableFetching: false,
    GetMADReportTableData: [],

    isMADReportRequestSelection: false,
    isMADReportRequestSelectionFetching: false,

    isGetMADReportClientConfig: false,
    isGetMADReportClientConfigFetching: false,
    GetMADReportClientConfigData: {},

    isSaveMADReportClientConfig: false,
    isSaveMADReportClientConfigFetching: false,

    isGetMADKYCReportApi: false,
    isGetMADKYCReportApiFetching: false,
    GetMADKYCReportApiData: [],

    isGetMCAReportListByUserName: false,
    isGetMCAReportListByUserNameFetching: false,
    GetMCAReportListByUserNameData: [],

    isSearchMCACompanies: false,
    isSearchMCACompaniesFetching: false,
    SearchMCACompaniesData: {},

    isSaveMCAReport: false,
    isSaveMCAReportFetching: false,
  },
  reducers: {
    updateStateMad: (state, { payload }) => {
      //  successMessage errorMessage isError
      state.successMessageMad =
        payload.successMessageMad !== undefined
          ? payload.successMessageMad
          : state.successMessageMad;
      state.errorMessageMad =
        payload.errorMessageMad !== undefined
          ? payload.errorMessageMad
          : state.errorMessageMad;
      state.isErrorMad =
        payload.isErrorMad !== undefined
          ? payload.isErrorMad
          : state.isErrorMad;

      //isSaveMADReport
      state.isSaveMADReport =
        payload.isSaveMADReport !== undefined
          ? payload.isSaveMADReport
          : state.isSaveMADReport;

      //MADReportRequestSelection
      state.isMADReportRequestSelection =
        payload.isMADReportRequestSelection !== undefined
          ? payload.isMADReportRequestSelection
          : state.isMADReportRequestSelection;

      //isSaveMADReportUpload
      state.isSaveMADReportUpload =
        payload.isSaveMADReportUpload !== undefined
          ? payload.isSaveMADReportUpload
          : state.isSaveMADReportUpload;

      //GetMADReportTable
      state.isGetMADReportTable =
        payload.isGetMADReportTable !== undefined
          ? payload.isGetMADReportTable
          : state.isGetMADReportTable;

      //SaveMADReportClientConfig
      state.isSaveMADReportClientConfig =
        payload.isSaveMADReportClientConfig !== undefined
          ? payload.isSaveMADReportClientConfig
          : state.isSaveMADReportClientConfig;

      //GetMADKYCReportApi
      state.isGetMADKYCReportApi =
        payload.isGetMADKYCReportApi !== undefined
          ? payload.isGetMADKYCReportApi
          : state.isGetMADKYCReportApi;
      state.GetMADKYCReportApiData =
        payload.GetMADKYCReportApiData !== undefined
          ? payload.GetMADKYCReportApiData
          : state.GetMADKYCReportApiData;

      //SavePolygons
      state.isSavePolygons =
        payload.isSavePolygons !== undefined
          ? payload.isSavePolygons
          : state.isSavePolygons;

      //SearchMCACompanies
      state.isSearchMCACompanies =
        payload.isSearchMCACompanies !== undefined
          ? payload.isSearchMCACompanies
          : state.isSearchMCACompanies;

      //SaveMCAReport
      state.isSaveMCAReport =
        payload.isSaveMCAReport !== undefined
          ? payload.isSaveMCAReport
          : state.isSaveMCAReport;
    },
  },
  extraReducers: (builder) => {
    //========= SaveMADReport
    builder.addCase(SaveMADReport.fulfilled, (state, { payload }) => {
      try {
        state.successMessageMad = payload.successMessage;
        state.isSaveMADReport = true;
        state.isSaveMADReportFetching = false;

        state.isErrorMad = false;
        state.errorMessageMad = "";
        return state;
      } catch (error) {
        console.error(
          "Error: SaveMADReport.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(SaveMADReport.rejected, (state, { payload }) => {
      try {
        state.successMessageMad = "";
        state.isSaveMADReport = false;
        state.isSaveMADReportFetching = false;
        state.isErrorMad = true;
        payload
          ? (state.errorMessageMad = payload.error.message
            ? payload.error.message
            : payload.error)
          : (state.errorMessageMad = "API result Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [SaveMADReport.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(SaveMADReport.pending, (state) => {
      state.isSaveMADReportFetching = true;
    });
    //========= SaveMADReportUpload
    builder.addCase(SaveMADReportUpload.fulfilled, (state, { payload }) => {
      try {
        state.successMessageMad = payload.successMessage;
        state.isSaveMADReportUpload = true;
        state.isSaveMADReportUploadFetching = false;

        state.isErrorMad = false;
        state.errorMessageMad = "";
        return state;
      } catch (error) {
        console.error(
          "Error: SaveMADReportUpload.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(SaveMADReportUpload.rejected, (state, { payload }) => {
      try {
        state.successMessageMad = "";
        state.isSaveMADReportUpload = false;
        state.isSaveMADReportUploadFetching = false;
        state.isErrorMad = true;
        payload
          ? (state.errorMessageMad = payload.error.message
            ? payload.error.message
            : payload.error)
          : (state.errorMessageMad = "API result Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [SaveMADReportUpload.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(SaveMADReportUpload.pending, (state) => {
      state.isSaveMADReportUploadFetching = true;
    });
    //========= GetMADReportTable
    builder.addCase(GetMADReportTable.fulfilled, (state, { payload }) => {
      try {
        state.isGetMADReportTable = true;
        state.isGetMADReportTableFetching = false;
        state.GetMADReportTableData = payload.data;
        state.isErrorMad = false;
        state.errorMessageMad = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetMADReportTable.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetMADReportTable.rejected, (state, { payload }) => {
      try {
        state.isGetMADReportTable = false;
        state.isGetMADReportTableFetching = false;
        state.GetMADReportTableData = [];
        state.isErrorMad = true;
        payload
          ? (state.errorMessageMad = payload.error.message
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessageMad = "API result Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetMADReportTable.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetMADReportTable.pending, (state) => {
      state.isGetMADReportTableFetching = true;
    });
    //========= MADReportRequestSelection
    builder.addCase(MADReportRequestSelection.fulfilled, (state, { payload }) => {
      try {
        state.isMADReportRequestSelection = true;
        state.isMADReportRequestSelectionFetching = false;
        state.successMessageMad = payload.successMessages || "Dada saved successfully";
        state.isErrorMad = false;
        state.errorMessageMad = "";
        return state;
      } catch (error) {
        console.error(
          "Error: MADReportRequestSelection.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(MADReportRequestSelection.rejected, (state, { payload }) => {
      try {
        state.isMADReportRequestSelection = false;
        state.isMADReportRequestSelectionFetching = false;
        state.isErrorMad = true;
        payload
          ? (state.errorMessageMad = payload.error.message
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessageMad = "API result Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [MADReportRequestSelection.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(MADReportRequestSelection.pending, (state) => {
      state.isMADReportRequestSelectionFetching = true;
    });
    //========= GetMADReportClientConfig
    builder.addCase(GetMADReportClientConfig.fulfilled, (state, { payload }) => {
      try {
        state.isGetMADReportClientConfig = true;
        state.isGetMADReportClientConfigFetching = false;
        state.GetMADReportClientConfigData = payload.data;
        state.isErrorMad = false;
        state.errorMessageMad = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetMADReportClientConfig.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetMADReportClientConfig.rejected, (state, { payload }) => {
      try {
        state.isGetMADReportClientConfig = false;
        state.isGetMADReportClientConfigFetching = false;
        state.GetMADReportClientConfigData = {};
        state.isErrorMad = true;
        payload
          ? (state.errorMessageMad = payload.error.message
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessageMad = "API result Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetMADReportClientConfig.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetMADReportClientConfig.pending, (state) => {
      state.isGetMADReportClientConfigFetching = true;
    });
    //========= SaveMADReportClientConfig
    builder.addCase(SaveMADReportClientConfig.fulfilled, (state, { payload }) => {
      try {
        state.isSaveMADReportClientConfig = true;
        state.isSaveMADReportClientConfigFetching = false;
        state.successMessageMad = payload.successMessage;
        state.isErrorMad = false;
        state.errorMessageMad = "";
        return state;
      } catch (error) {
        console.error(
          "Error: SaveMADReportClientConfig.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(SaveMADReportClientConfig.rejected, (state, { payload }) => {
      try {
        state.isSaveMADReportClientConfig = false;
        state.isSaveMADReportClientConfigFetching = false;
        state.successMessageMad = "";
        state.isErrorMad = true;
        payload
          ? (state.errorMessageMad = payload.error.message
            ? payload.error.message
            : payload.error)
          : (state.errorMessageMad = "API result Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [SaveMADReportClientConfig.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(SaveMADReportClientConfig.pending, (state) => {
      state.isSaveMADReportClientConfigFetching = true;
    });
    //========= GetMADKYCReportApi
    builder.addCase(GetMADKYCReportApi.fulfilled, (state, { payload }) => {
      try {
        state.isGetMADKYCReportApi = true;
        state.isGetMADKYCReportApiFetching = false;
        state.GetMADKYCReportApiData = payload.data;
        state.isErrorMad = false;
        state.errorMessageMad = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetMADKYCReportApi.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetMADKYCReportApi.rejected, (state, { payload }) => {
      try {
        state.isGetMADKYCReportApi = false;
        state.isGetMADKYCReportApiFetching = false;
        state.GetMADKYCReportApiData = [];
        state.isErrorMad = true;
        payload
          ? (state.errorMessageMad = payload.error.message
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessageMad = "API result Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetMADKYCReportApi.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetMADKYCReportApi.pending, (state) => {
      state.isGetMADKYCReportApiFetching = true;
    });
    //========= SavePolygons
    builder.addCase(SavePolygons.fulfilled, (state, { payload }) => {
      try {
        state.isSavePolygons = true;
        state.isSavePolygonsFetching = false;
        state.isErrorMad = false;
        state.successMessageMad = payload.successMessage;
        state.errorMessageMad = "";
        return state;
      } catch (error) {
        console.error(
          "Error: SavePolygons.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(SavePolygons.rejected, (state, { payload }) => {
      try {
        state.isSavePolygons = false;
        state.isSavePolygonsFetching = false;
        state.isErrorMad = true;
        payload
          ? (state.errorMessageMad = payload.error.message
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessageMad = "API result Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [SavePolygons.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(SavePolygons.pending, (state) => {
      state.isSavePolygonsFetching = true;
    });
    //========= GetMCAReportListByUserName
    builder.addCase(GetMCAReportListByUserName.fulfilled, (state, { payload }) => {
      try {
        state.isGetMCAReportListByUserName = true;
        state.isGetMCAReportListByUserNameFetching = false;
        state.GetMCAReportListByUserNameData = payload.data;
        state.isErrorMad = false;
        state.errorMessageMad = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetMCAReportListByUserName.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetMCAReportListByUserName.rejected, (state, { payload }) => {
      try {
        state.isGetMCAReportListByUserName = false;
        state.isGetMCAReportListByUserNameFetching = false;
        state.isErrorMad = true;
        payload
          ? (state.errorMessageMad = payload.error.message
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessageMad = "API result Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetMCAReportListByUserName.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetMCAReportListByUserName.pending, (state) => {
      state.isGetMCAReportListByUserNameFetching = true;
    });
    //========= SearchMCACompanies
    builder.addCase(SearchMCACompanies.fulfilled, (state, { payload }) => {
      try {
        state.isSearchMCACompanies = true;
        state.isSearchMCACompaniesFetching = false;
        state.SearchMCACompaniesData = payload;
        state.isErrorMad = false;
        state.errorMessageMad = "";
        return state;
      } catch (error) {
        console.error(
          "Error: SearchMCACompanies.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(SearchMCACompanies.rejected, (state, { payload }) => {
      try {
        state.isSearchMCACompanies = false;
        state.isSearchMCACompaniesFetching = false;
        state.isErrorMad = true;
        payload
          ? (state.errorMessageMad = payload.error.message
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessageMad = "API result Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [SearchMCACompanies.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(SearchMCACompanies.pending, (state) => {
      state.isSearchMCACompaniesFetching = true;
    });
    //========= SaveMCAReport
    builder.addCase(SaveMCAReport.fulfilled, (state, { payload }) => {
      try {
        state.isSaveMCAReport = true;
        state.isSaveMCAReportFetching = false;
        state.isErrorMad = false;
        state.errorMessageMad = "";
        state.successMessageMad = "Report saved successfully.";
        return state;
      } catch (error) {
        console.error(
          "Error: SaveMCAReport.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(SaveMCAReport.rejected, (state, { payload }) => {
      try {
        state.isSaveMCAReport = false;
        state.isSaveMCAReportFetching = false;
        state.isErrorMad = true;
        payload
          ? (state.errorMessageMad = payload.error.message
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessageMad = "API result Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [SaveMCAReport.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(SaveMCAReport.pending, (state) => {
      state.isSaveMCAReportFetching = true;
    });
  },
});

export const { updateStateMad } = MADSlice.actions;
export const MADSelector = (state) => state.main.MAD;
